import { type ComponentProps } from 'react';

export const LargePlayerIcon = (props: ComponentProps<'svg'>) => (
  <svg width="112" height="112" viewBox="0 0 112 112" fill="none" {...props}>
    <circle cx="57.4006" cy="23.8" r="9.8" fill="currentColor" />
    <ellipse
      cx="87.9091"
      cy="49.0098"
      rx="8.4"
      ry="5.6"
      transform="rotate(-60 87.9091 49.0098)"
      fill="currentColor"
    />
    <path
      d="M71.2148 30.8008L89.3109 44.0486"
      stroke="currentColor"
      strokeWidth="5.6"
      strokeLinecap="round"
    />
    <path
      d="M57.3992 63C57.3992 56.2152 59.5332 49.1459 60.7594 45.6438C61.2158 44.3405 60.7312 42.8687 59.5528 42.1487L38.9684 29.57C37.5807 28.722 37.205 26.874 38.1514 25.5514L46.2934 14.173C47.7074 12.197 47.0015 9.42376 44.8149 8.36427C43.1679 7.56627 41.188 8.01408 40.0447 9.44314L28.1499 24.3116C26.4455 26.4422 26.5246 29.4911 28.3373 31.5303L35.5243 39.6157C36.0784 40.2391 36.3258 41.0772 36.199 41.9017L34.8427 50.7173C34.0149 56.0979 33.5992 61.5339 33.5992 66.9778V98C33.5992 101.093 36.1064 103.6 39.1992 103.6C42.292 103.6 44.7992 101.093 44.7992 98V73.5216C44.7992 72.2623 46.4888 71.8493 47.0698 72.9665L60.424 98.6477C61.7988 101.291 65.1642 102.157 67.6436 100.504C69.7778 99.081 70.4998 96.283 69.3506 93.9899C65.4627 86.2325 57.3992 69.375 57.3992 63Z"
      fill="currentColor"
    />
  </svg>
);
